import { render, staticRenderFns } from "./MagTeasers.vue?vue&type=template&id=95ac3ac0&scoped=true"
import script from "./MagTeasers.vue?vue&type=script&lang=js"
export * from "./MagTeasers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95ac3ac0",
  null
  
)

export default component.exports